import NumberFlow from '@number-flow/react';
import { Minus, Plus } from 'lucide-react';

import { Button } from 'src/components/ui/button';
import { Slider } from 'src/components/ui/slider';

type ForecastPaginatedControlProps = {
  label: string;
  value: number;
  handleDecrease: () => void;
  handleIncrease: () => void;
  setValue: (value: number) => void;
};

export function ForecastPaginatedControl({
  label,
  value,
  handleDecrease,
  handleIncrease,
  setValue,
}: ForecastPaginatedControlProps) {
  return (
    <div className='flex flex-col gap-y-2'>
      <div className='flex flex-row items-center gap-x-2 text-sm'>
        <span>{label}</span>
        <NumberFlow
          className='text-layout-foreground-secondary'
          value={value}
        />
      </div>
      <div className='flex flex-row items-center gap-x-2'>
        <Button
          className='px-2'
          onClick={handleDecrease}
          size='icon'
          variant='outline'
        >
          <Minus className='h-4 w-4' strokeWidth={2} />
        </Button>
        <Slider
          className='w-full'
          max={10}
          min={1}
          onValueChange={(value) => setValue(value[0])}
          step={1}
          value={[value]}
        />
        <Button
          className='px-2'
          onClick={handleIncrease}
          size='icon'
          variant='outline'
        >
          <Plus className='h-4 w-4' strokeWidth={2} />
        </Button>
      </div>
    </div>
  );
}
